<template>
  <div class="box">
    <el-form :model="info" label-position="right" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" size="small">
      <el-form-item label="名称" prop="title">
        <el-input v-model="info.title" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="广告类型" prop="ad_type">
        <el-radio-group v-model="info.ad_type">
          <el-radio :label="item.id" v-for="(item,index) in adTypeList" :key="index">{{ item.title }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="广告有效期">
        <el-date-picker
            size="small"
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="广告图" prop="img">
        <SelectImgs :selectNum="1" :selectData="[info.img]" :selectFunc="fileChoose"></SelectImgs>
        <div class="c666 font-14 mg-tp-20" v-if="info.ad_type==1">750*1334px</div>
        <div class="c666 font-14 mg-tp-20" v-if="info.ad_type==2">500*500px</div>
      </el-form-item>
      <el-form-item label="链接" prop="link">
        <select-link :setData="info.link" :setFunc="setNavFunc">
          <template slot="button">
            <el-input :value="info.link.title" size="small" placeholder="点击设置链接" suffix-icon="el-icon-arrow-right" readonly="readonly"></el-input>
          </template>
        </select-link>
      </el-form-item>
      <el-form-item label="排序" prop="ordering">
        <el-input v-model="info.ordering" placeholder="请输入序号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button type="button" @click="reBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import SelectImgs from '@/components/SelectImgs'
import selectLink from '@/view/module/select.link.vue'
import variable from "@/utils/variable";
export default {
  data() {
    return {
      showModal: false,
      dateRange: ['',''],
      info: {
        id: 0,
        title: "",
        img: "",
        ordering: "",
        ad_type: 1,
        link: {
          type: '',
          name: '',
          id: ''
        }
      },
      adTypeList: variable.adTypeList,
      source_domain: this.config.SOURCE_DOMAIN,
      rules: {
        title: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        ad_type: [
          { required: true, message: '请选择广告类型', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请上传广告图', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    SelectImgs,
    selectLink
  },
  created() {
    if(this.$route.query.id) {
      this.info.id = this.$route.query.id
      this.getInfo()
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    fileChoose(item) {
      this.info.img = item.pic
    },
    setNavFunc(item) {
      this.info.link = item
    },
    getInfo() {
      this.showLoading()
      this.$api.marking.adInfo({id: this.info.id}, res => {
        this.hideLoading()
        if(res.errcode == 0) {
          this.info = res.data
          this.dateRange = [this.info.start_time,this.info.end_time]
        } else {
          this.fail(res.errmsg)
        }
      })
    },
    submitForm(formName) {
      var that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var param = that.info
          param.start_time = this.dateRange[0]
          param.end_time = this.dateRange[1]
          if(param.start_time=='') {
            this.fail('有效期不能为空')
            return false;
          }
          this.$api.marking.adEdit(param,function (res) {
            if(res.errcode == 0) {
              that.success(res.errmsg)
              that.reBack()
            } else {
              that.fail(res.errmsg)
            }
          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
  .box {
    background-color: #fff;
    padding: 20px;
    border-radius: 6px;
    min-height: 500px;
  }
  .ruleForm {
    width: 800px;
  }
</style>
